import { Button, ButtonProps } from 'framework/ui/mui-builder';

type InterruptionActionButtonProps = ButtonProps & {
  minWidth?: number;
};

const BUTTON_SX = {
  minWidth: 80,
  height: 28,
  borderRadius: 1,
  px: 1,
  py: 0.25,
  fontSize: 12,
  lineHeight: 1.2,
  textTransform: 'none',
  backgroundColor: 'var(--mui-palette-background-paper)',
  '&&, &&:hover': {
    borderColor: 'border.default',
  },
} as const;

const getButtonSx = (minWidth?: number, sx?: ButtonProps['sx']) => ({
  ...BUTTON_SX,
  minWidth: minWidth ?? BUTTON_SX.minWidth,
  ...sx,
});

const InterruptionActionButton = ({ minWidth, sx, ...props }: InterruptionActionButtonProps) => {
  return <Button {...props} sx={getButtonSx(minWidth, sx)} />;
};

export default InterruptionActionButton;
